export default "__VITE_ASSET__c6accd50__"